import type { SVGProps } from 'react'
const SvgInfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.25 4.08333H6.41667V2.91667H5.25M5.83333 10.5C3.26083 10.5 1.16667 8.40583 1.16667 5.83333C1.16667 3.26083 3.26083 1.16667 5.83333 1.16667C8.40583 1.16667 10.5 3.26083 10.5 5.83333C10.5 8.40583 8.40583 10.5 5.83333 10.5ZM5.83333 0C5.06729 0 4.30875 0.150884 3.60101 0.444036C2.89328 0.737189 2.25022 1.16687 1.70854 1.70854C0.614582 2.80251 0 4.28624 0 5.83333C0 7.38043 0.614582 8.86416 1.70854 9.95812C2.25022 10.4998 2.89328 10.9295 3.60101 11.2226C4.30875 11.5158 5.06729 11.6667 5.83333 11.6667C7.38043 11.6667 8.86416 11.0521 9.95812 9.95812C11.0521 8.86416 11.6667 7.38043 11.6667 5.83333C11.6667 5.06729 11.5158 4.30875 11.2226 3.60101C10.9295 2.89328 10.4998 2.25022 9.95812 1.70854C9.41645 1.16687 8.77339 0.737189 8.06565 0.444036C7.35792 0.150884 6.59938 0 5.83333 0M5.25 8.75H6.41667V5.25H5.25V8.75Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgInfoIcon
